import { useQuery }               from '@apollo/client'
import { useState }               from 'react'
import { GET_SETTINGS_BY_HANDLE } from '../../graphql/settings'
import { appCdnUrl }              from '../../utilities'

type BannerConfig = {
  title?: string
  description?: string
  ctaTitle?: string
  link?: string
  imageUrl?: string
  imageWideDesktopUrl?: string
  imageDesktopUrl?: string
  imageTabletUrl?: string
  imageMobileUrl?: string
}

export default function Hero(): JSX.Element {
  const [ bannerConfig, setBannerConfig ] = useState<BannerConfig | null>( null )

  const getImageSrc = ( imageUrl?: string ): string => imageUrl ? appCdnUrl + imageUrl : ''

  useQuery( GET_SETTINGS_BY_HANDLE, {
    variables:   { input: { handle: 'dashboard-banner' } },
    onCompleted: ( { settingsByHandle }: any ): any => {
      if ( settingsByHandle ) {
        setBannerConfig( settingsByHandle.config )
      }
    },
    onError:     ( e: any ) => {
      console.error( e )
    }
  } )

  const desktopImage = getImageSrc( bannerConfig?.imageDesktopUrl || bannerConfig?.imageUrl )
  const wideDesktopImage = getImageSrc( bannerConfig?.imageWideDesktopUrl || bannerConfig?.imageDesktopUrl || bannerConfig?.imageUrl )
  const tabletImage  = getImageSrc( bannerConfig?.imageTabletUrl || bannerConfig?.imageDesktopUrl || bannerConfig?.imageUrl )
  const mobileImage  = getImageSrc( bannerConfig?.imageMobileUrl || bannerConfig?.imageTabletUrl || bannerConfig?.imageDesktopUrl || bannerConfig?.imageUrl )
  const bannerClassName = `dashboard-hero-banner flex flex-col w-full rounded-xl overflow-hidden relative${ bannerConfig?.imageWideDesktopUrl ? ' dashboard-hero-banner--wide' : '' }`

  return (
    <>
      { bannerConfig && desktopImage &&
        <div className={ bannerClassName }>
          <picture className="absolute inset-0 h-full w-full">
            <source media="(min-width: 1920px)" srcSet={ wideDesktopImage } />
            <source media="(max-width: 767px)" srcSet={ mobileImage } />
            <source media="(max-width: 1199px)" srcSet={ tabletImage } />
            <img
              src={ desktopImage }
              alt=""
              className="h-full w-full object-cover object-center"
            />
          </picture>

          <div className="flex-1 flex-grow overflow-hidden max-w-sm relative rounded-l-xl h-full w-full bg-gradient-to-r from-blue-primary/90 p-6 lg:p-8 xl:p-10">
            <div className="flex h-full flex-col items-start justify-center gap-4 text-white xl:gap-6">
              <h1 className="text-2xl font-semibold leading-tight xl:text-3xl">{ bannerConfig.title }</h1>
              <p>{ bannerConfig.description }</p>

              { bannerConfig.link?.length &&
                <a href={ bannerConfig.link } className="inline-block px-4 py-3 bg-yellow-primary text-sm font-medium rounded-full text-blue-primary">{ bannerConfig.ctaTitle }</a>
              }
            </div>
          </div>
        </div>
      }
    </>
  )
}
